module.exports = __webpack_public_path__ + "static/media/full-logo-white.6f0d76de.png";